import { createContext } from 'react';

export interface GaugeChartSizeProps {
  width: number;
  height: number;
}

export const GaugeChartSizeContext = createContext<
  GaugeChartSizeProps | undefined
>(undefined);
